import React from "react";
import Drawer from "@material-ui/core/Drawer";
import styled from "styled-components";
import COLORS from "../../../../assets/Colors";
import theme from "../../../../assets/theme";
import { PrimaryCTAButton } from "../../../common/Buttons";
import { Formik } from "formik";
import { StyledLabel } from "../../../pages/CaseDetails/styles";
import { useSnackbar } from "notistack";
import AWSService from "../../../../services/AWSService";
import useLoader from "../../../../hooks/useLoader";
import labels from "../../../../helpers/labels.json";
import { getErrorMessage, getFileName } from "../../../../helpers/functions";
import { CustomFileUpload } from "../../../common/FormInputs";

const validFormat = /(?:image)/;
export default function UpdateLogo({
  modal,
  setModal,
  systemConfig,
  handleSystemConfigChange = () => {},
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();

  async function s3Upload(file, field, setFieldValue, setFieldError) {
    if (file) {
      try {
        const errorMessage = "Invalid File Type";
        if (!validFormat.test(file?.type)) throw errorMessage;
        setLoader({ state: true, message: `Uploading file ${file.name} ...` });
        const payload = {
          key: file.name,
        };
        const s3Response = await AWSService.getS3URL(payload);
        if (s3Response.url) {
          const res = await AWSService.uploadToS3(s3Response.url, file);
          setFieldValue(field, res);
          enqueueSnackbar("Upload was successful", { variant: "success" });
        }
      } catch (error) {
        const message = getErrorMessage(error);
        setFieldError(field, "Could not upload this file");
        enqueueSnackbar(message, { variant: "error" });
      } finally {
        setLoader({ state: false });
      }
    }
  }

  return (
    <Drawer anchor={"right"} open={modal} onClose={() => setModal(false)}>
      <DrawerContainer role="presentation">
        <HeadingContainer>
          <Heading>Update Platform FavIcon</Heading>
          <CloseModal
            onClick={() => setModal(false)}
            src={require("../../../../assets/images/closeModal.svg")}
          />
        </HeadingContainer>
        <EditProfileContainer>
          <Formik
            initialValues={{
                faviconUrl: systemConfig?.faviconUrl || "",
            }}
            onSubmit={({ faviconUrl }) =>
              handleSystemConfigChange({ ...systemConfig, faviconUrl }, () =>
                setModal(false)
              )
            }
            validateOnBlur
            enableReinitialize
            validateOnChange
          >
            {({
              values,
              errors,
              handleSubmit,
              touched,
              setFieldError,
              setFieldValue,
              isValid,
            }) => (
              <StyledForm>
                <StyledFormElementsWrapper style={{ margin: "80px 0 74px", paddingLeft: "60px" }}>
                  <StyledLabel>
                    {labels.newFavIcon}
                    <span className="required-star"> *</span>
                  </StyledLabel>
                  <CustomFileUpload
                    key={`${values.faviconUrl}`}
                    error={touched.faviconUrl && errors.faviconUrl}
                    file={{ name: getFileName(values?.faviconUrl) }}
                    fileUrl={values?.faviconUrl}
                    setFile={(f) =>
                      s3Upload(f, "faviconUrl", setFieldValue, setFieldError)
                    }
                    accept="image/*"
                  />
                </StyledFormElementsWrapper>

                <ButtonContainer style={{ marginBottom: 13 }}>
                  <PrimaryCTAButton
                    type="submit"
                    onClick={handleSubmit}
                    disabled={!isValid || !values.faviconUrl}
                    style={{ width: 413, margin: "auto" }}
                  >
                    Update FavIcon
                  </PrimaryCTAButton>
                </ButtonContainer>
              </StyledForm>
            )}
          </Formik>
        </EditProfileContainer>
      </DrawerContainer>
    </Drawer>
  );
}
const DrawerContainer = styled.div`
  width: 618px;
`;
const HeadingContainer = styled.div`
  padding-top: 28px;
  padding-bottom: 20px;
  padding-left: 30px;
  padding-right: 54px;
  border-bottom: 1px solid ${COLORS.INPUT_BORDER};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const CloseModal = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
`;
const Heading = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontExtraBold};
  span {
    font-family: ${theme.fonts.primaryFontSemiBold};
    text-decoration: underline;
    margin-left: 23px;
    font-size: 12px;
    color: ${COLORS.BTN_GREEN};
    user-select: none;
  }
`;
const EditProfileContainer = styled.div`
  margin: 0 30px 0 30px;
`;
const StyledForm = styled.form`
  width: 100%;
`;
const StyledFormElementsWrapper = styled.div`
  margin-bottom: 28px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
`;
